"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getTilePriority = getTilePriority;

var _EventType = _interopRequireDefault(require("./events/EventType.js"));

var _PriorityQueue = _interopRequireWildcard(require("./structs/PriorityQueue.js"));

var _TileState = _interopRequireDefault(require("./TileState.js"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/TileQueue
 */


/**
 * @typedef {function(import("./Tile.js").default, string, import("./coordinate.js").Coordinate, number): number} PriorityFunction
 */
var TileQueue =
/** @class */
function (_super) {
  __extends(TileQueue, _super);
  /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */


  function TileQueue(tilePriorityFunction, tileChangeCallback) {
    var _this = _super.call(this,
    /**
     * @param {Array} element Element.
     * @return {number} Priority.
     */
    function (element) {
      return tilePriorityFunction.apply(null, element);
    },
    /**
     * @param {Array} element Element.
     * @return {string} Key.
     */
    function (element) {
      return (
        /** @type {import("./Tile.js").default} */
        element[0].getKey()
      );
    }) || this;
    /** @private */


    _this.boundHandleTileChange_ = _this.handleTileChange.bind(_this);
    /**
     * @private
     * @type {function(): ?}
     */

    _this.tileChangeCallback_ = tileChangeCallback;
    /**
     * @private
     * @type {number}
     */

    _this.tilesLoading_ = 0;
    /**
     * @private
     * @type {!Object<string,boolean>}
     */

    _this.tilesLoadingKeys_ = {};
    return _this;
  }
  /**
   * @param {Array} element Element.
   * @return {boolean} The element was added to the queue.
   */


  TileQueue.prototype.enqueue = function (element) {
    var added = _super.prototype.enqueue.call(this, element);

    if (added) {
      var tile = element[0];
      tile.addEventListener(_EventType["default"].CHANGE, this.boundHandleTileChange_);
    }

    return added;
  };
  /**
   * @return {number} Number of tiles loading.
   */


  TileQueue.prototype.getTilesLoading = function () {
    return this.tilesLoading_;
  };
  /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */


  TileQueue.prototype.handleTileChange = function (event) {
    var tile =
    /** @type {import("./Tile.js").default} */
    event.target;
    var state = tile.getState();

    if (state === _TileState["default"].LOADED || state === _TileState["default"].ERROR || state === _TileState["default"].EMPTY) {
      tile.removeEventListener(_EventType["default"].CHANGE, this.boundHandleTileChange_);
      var tileKey = tile.getKey();

      if (tileKey in this.tilesLoadingKeys_) {
        delete this.tilesLoadingKeys_[tileKey];
        --this.tilesLoading_;
      }

      this.tileChangeCallback_();
    }
  };
  /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */


  TileQueue.prototype.loadMoreTiles = function (maxTotalLoading, maxNewLoads) {
    var newLoads = 0;
    var state, tile, tileKey;

    while (this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0) {
      tile =
      /** @type {import("./Tile.js").default} */
      this.dequeue()[0];
      tileKey = tile.getKey();
      state = tile.getState();

      if (state === _TileState["default"].IDLE && !(tileKey in this.tilesLoadingKeys_)) {
        this.tilesLoadingKeys_[tileKey] = true;
        ++this.tilesLoading_;
        ++newLoads;
        tile.load();
      }
    }
  };

  return TileQueue;
}(_PriorityQueue["default"]);

var _default = TileQueue;
/**
 * @param {import('./PluggableMap.js').FrameState} frameState Frame state.
 * @param {import("./Tile.js").default} tile Tile.
 * @param {string} tileSourceKey Tile source key.
 * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
 * @param {number} tileResolution Tile resolution.
 * @return {number} Tile priority.
 */

exports["default"] = _default;

function getTilePriority(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
  // Filter out tiles at higher zoom levels than the current zoom level, or that
  // are outside the visible extent.
  if (!frameState || !(tileSourceKey in frameState.wantedTiles)) {
    return _PriorityQueue.DROP;
  }

  if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) {
    return _PriorityQueue.DROP;
  } // Prioritize the highest zoom level tiles closest to the focus.
  // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
  // Within a zoom level, tiles are prioritized by the distance in pixels between
  // the center of the tile and the center of the viewport.  The factor of 65536
  // means that the prioritization should behave as desired for tiles up to
  // 65536 * Math.log(2) = 45426 pixels from the focus.


  var center = frameState.viewState.center;
  var deltaX = tileCenter[0] - center[0];
  var deltaY = tileCenter[1] - center[1];
  return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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